export const package_fields = [
    {
        key: 'id',
        label: '#',
        sortable: true
    },
    {
        key: 'first_name',
        label: 'First Name',
        sortable: true,
    },
    {
        key: 'phone_number',
        label: 'Phone Number',
        sortable: true,
    },
    {
        key: 'product_name',
        label: 'Package',
        sortable: true
    },
    {
        key: 'saved_amount',
        sortable: true,
    },
    {
        key: 'maturity_date',
        sortable: true,
    }
];

